import {
  formItemTypeEnum,
  matchModeEnum,
  operatorEnum,
} from '@sttedra_ui/framework';

const checkboxProperties = {
  binary: true,
  truValue: true,
  falseValue: false,
};
const customChipClassification = (f) => !!f.value ? 'verdadero' : 'falso';

export const MOUNTAIN_PORTS_SCHEMA = [
  {
    field: 'name',
    label: 'Nombre',
  },
  {
    field: 'province',
    label: 'Provincia',
  },
  {
    field: 'highway',
    label: 'Carretera',
  },
  {
    field: 'height',
    label: 'Altitud',
    classObj: ['query__header--align-right'],
  },
  {
    field: 'category',
    label: 'Categoría',
    sortable: true,
  },
];

export const MOUNTAIN_PORTS_FILTERS = [
  {
    field: 'm',
    label: 'Puertos con problemas de nieve',
    icon: 'ac_unit',
    type: formItemTypeEnum.CHECKBOX,
    matchMode: matchModeEnum.EQUALS,
    operator: operatorEnum.OR,
    value: false,
    properties: checkboxProperties,
    custom: {
      chip: customChipClassification,
    },
    classObj: [
      'block--classification-item',
      'block--classification-item__3column',
      'block--bg-category',
      'block--bg-category-snow-problems-ports',
    ],
  },
  {
    field: 'd',
    label: 'Grandes puertos con problemas de nieve',
    icon: 'severe_cold',
    type: formItemTypeEnum.CHECKBOX,
    matchMode: matchModeEnum.EQUALS,
    operator: operatorEnum.OR,
    value: false,
    properties: checkboxProperties,
    custom: {
      chip: customChipClassification,
    },
    classObj: [
      'block--classification-item',
      'block--classification-item__3column',
      'block--bg-category',
      'block--bg-category-snow-problems-big-ports',
    ],
  },
  {
    field: 's',
    label: 'Puertos sin problemas de nieve',
    icon: 'downhill_skiing',
    type: formItemTypeEnum.CHECKBOX,
    matchMode: matchModeEnum.EQUALS,
    operator: operatorEnum.OR,
    value: false,
    properties: checkboxProperties,
    custom: {
      chip: customChipClassification,
    },
    classObj: [
      'block--classification-item',
      'block--classification-item__3column',
      'block--bg-category',
      'block--bg-category-no-snow-problems-ports',
    ],
  },
];
